import UIHelper from 'general/helpers/UIHelper';
import useRouter from 'hooks/useRouter';
import ChargeStationDetailView from '../../components/ChargeStationDetailView';

ChargeStationDetailScreen.propTypes = {};

function ChargeStationDetailScreen(props) {
  // MARK: ---- PROPERTIES ----
  const router = useRouter();
  const chargeStationId = router.query?.chargeStationId;

  return (
    <div>
      {/* breadcrumb */}
      <div>
        {UIHelper.buildBreadcrumb([
          {
            title: 'Danh sách trạm sạc',
            onPress: () => {
              router.navigate(-1);
            },
          },
          { title: 'Chi tiết trạm sạc' },
        ])}
      </div>
      <div className="my-4">
        <ChargeStationDetailView chargeStationId={chargeStationId} />
      </div>
    </div>
  );
}

export default ChargeStationDetailScreen;
